/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import FilterConstants from '../../filter-constants';
import Chebyshev from './chebyshev';
import Butterworth from './butterworth';
import Bessel from './bessel';
import ButterworthBessel from './butterworth-bessel';

export default class FilterResponse extends EmberObject {
  selectedResponseType;
  @computed('selectedResponseType') get instance() {
    var selectedResponseType = this.selectedResponseType;
    var result = Butterworth.create();
    if (selectedResponseType === FilterConstants.responseType.chebyshev) {
      result = Chebyshev.create();
    } else if (selectedResponseType === FilterConstants.responseType.bessel) {
      result = Bessel.create();
    } else if (selectedResponseType === FilterConstants.responseType.butterworthBessel) {
      result = ButterworthBessel.create();
    }

    return result;
  }

  @computed('instance') get name() {
    return this.instance.name;
  }

  lowPass(passbandAttenuation, stopbandAttenuation, passbandFrequency, stopbandFrequency, filterResponseValue) {
    var instance = this.instance;
    var result = instance.lowPass(
      passbandAttenuation,
      stopbandAttenuation,
      passbandFrequency,
      stopbandFrequency,
      filterResponseValue,
    );
    return result;
  }

  getOrder(passbandAttenuation, stopbandAttenuation, passbandFrequency, stopbandFrequency, filterResponseValue) {
    var instance = this.instance;
    var result = instance.getOrder(
      passbandAttenuation,
      stopbandAttenuation,
      passbandFrequency,
      stopbandFrequency,
      filterResponseValue,
    );
    return result;
  }

  getNumberOfStages(
    passbandAttenuation,
    stopbandAttenuation,
    passbandFrequency,
    stopbandFrequency,
    filterResponseValue,
  ) {
    var instance = this.instance;
    var result = instance.getNumberOfStages(
      passbandAttenuation,
      stopbandAttenuation,
      passbandFrequency,
      stopbandFrequency,
      filterResponseValue,
    );
    return result;
  }
}
